import { Box } from '@mui/material';
import MuiBreadcrumbs from 'app/design/uiComponents/MuiBreadcrumbs';
import { PageTitleBackVariant, PageTitleDefaultVariant } from '.';
import { PageTitleInactiveVariantProps } from '../types';
import { useGetMediaQueryUp } from 'app/hooks/useGetMediaQuery';

const PageTitleInactiveVariant = ({
  title,
  note,
  buttonText,
  buttonHandleClick,
  breadcrumbLinks,
  breadcrumb,
  rightElement,
}: PageTitleInactiveVariantProps) => {
  const isMdUp = useGetMediaQueryUp('md');
  return (
    <Box>
      {!isMdUp ? (
        <PageTitleBackVariant
          buttonText={buttonText}
          buttonHandleClick={buttonHandleClick}
        />
      ) : breadcrumb !== undefined ? (
        <Box className="m-main-spacing" sx={{ pt: 3, pb: 0 }}>
          {breadcrumb}
        </Box>
      ) : (
        <Box className="m-main-spacing" sx={{ pt: 3, pb: 0 }}>
          <MuiBreadcrumbs links={breadcrumbLinks!} />
        </Box>
      )}
      <PageTitleDefaultVariant
        title={title}
        note={note}
        rightElement={rightElement}
      />
    </Box>
  );
};

export default PageTitleInactiveVariant;
